'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApplicationManager = require('./lib/ApplicationManager');

var _ApplicationManager2 = _interopRequireDefault(_ApplicationManager);

var _SecurityManager = require('./lib/SecurityManager');

var _SecurityManager2 = _interopRequireDefault(_SecurityManager);

var _LegacyStorage = require('./lib/storage/LegacyStorage');

var _LegacyStorage2 = _interopRequireDefault(_LegacyStorage);

var _MemoryStorage = require('./lib/storage/MemoryStorage');

var _MemoryStorage2 = _interopRequireDefault(_MemoryStorage);

var _DataAccess = require('./lib/DataAccess');

var _DataAccess2 = _interopRequireDefault(_DataAccess);

var _ModelMapper = require('./lib/ModelMapper');

var _ModelMapper2 = _interopRequireDefault(_ModelMapper);

var _NavigationManager = require('./lib/NavigationManager');

var _NavigationManager2 = _interopRequireDefault(_NavigationManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

require('../scss/base/style.scss');

var Application = function () {
  function Application() {
    _classCallCheck(this, Application);

    this.version = '2.0.0';
    this.buildTimestamp = 'Sun Jun 25 2017 17:18:30 GMT+0200 (W. Europe Daylight Time)';
    this.message = function (message) {
      console.log('Got message', message);
      dispatchEvent(new Event(message));
    };
    this.session = {};

    this.applicationManager = new _ApplicationManager2.default();
    this.securityManager = new _SecurityManager2.default();
    this.externalStorage = new _LegacyStorage2.default('/api');
    this.localStorage = new _MemoryStorage2.default();
    this.navigationManager = null;
    this.dataAccess = new _DataAccess2.default(this.securityManager, this.localStorage, this.externalStorage, this.message);
    this.modelMapper = new _ModelMapper2.default();
    this.exceptionHandler = function (e) {
      if (e) {
        if (e.stack) {
          console.error(e, e.stack);
        } else {
          console.error(e);
        }
      } else {
        console.error('Uncaught exception');
      }
    };
    this.bootMessage = null;
    this.reloadLink = null;
    this.indicator = null;
    this.viewport = null;
    this.delayedNavigation = false;
    this.License = null;
  }

  _createClass(Application, [{
    key: 'getUtcTimestamp',
    value: function getUtcTimestamp(date) {
      return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    }
  }, {
    key: 'getLocalTimestamp',
    value: function getLocalTimestamp(date) {
      return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    }
  }, {
    key: 'init',
    value: function init() {
      var _this = this;

      this.viewport = document.getElementById('viewport');
      var boot = document.getElementById('boot');

      this.bootMessage = document.createElement('div');
      this.bootMessage.className = 'messages';
      boot.appendChild(this.bootMessage);
      this.createReloadLink();
      boot.appendChild(this.reloadLink);
      this.createIndicator();
      document.body.appendChild(this.indicator);

      this.setMessage('Versie: ' + this.version + ' (' + this.buildTimestamp + ')');
      this.setMessage('Bezig met opstarten...');

      onerror = function onerror() {
        _this.setMessage('Helaas, door een onbekende fout met uw externe opslag kan PRIM niet gestart worden.');
        _this.showReloadLink();
      };

      addEventListener('write', this.showWriteIndicator.bind(this));
      addEventListener('writePending', this.showWritePendingIndicator.bind(this));
      addEventListener('writeFailed', this.showWriteFailedIndicator.bind(this));
      addEventListener('read', this.showReadIndicator.bind(this));
      addEventListener('readPending', this.showReadPendingIndicator.bind(this));

      this.capabilityCheck();
    }
  }, {
    key: 'writeStatus',
    value: function writeStatus() {
      document.body.classList.remove('writeFailed');
      document.body.classList.add('writing');
    }
  }, {
    key: 'writeFailedStatus',
    value: function writeFailedStatus() {
      document.body.classList.remove('writing');
      document.body.classList.add('writeFailed');
    }
  }, {
    key: 'clearStatus',
    value: function clearStatus() {
      document.body.classList.remove('writeFailed');
      document.body.classList.remove('writing');
    }
  }, {
    key: 'setMessage',
    value: function setMessage(message) {
      this.bootMessage.innerHTML += message + '<br />';

      var isScrolledToBottom = this.bootMessage.scrollHeight - this.bootMessage.clientHeight <= this.bootMessage.scrollTop + 1;

      if (isScrolledToBottom) {
        this.bootMessage.scrollTop = this.bootMessage.scrollHeight - this.bootMessage.clientHeight;
      }
    }
  }, {
    key: 'showReloadLink',
    value: function showReloadLink() {
      this.reloadLink.setAttribute('style', '');
    }
  }, {
    key: 'initApplication',
    value: function initApplication() {
      this.initNavigation('/entercredentials/');
    }
  }, {
    key: 'initExternalStorage',
    value: function initExternalStorage() {
      var _this2 = this;

      this.setMessage('Controle gegevens uit externe opslag...');
      this.externalStorage.status().then(function () {
        _this2.externalStorage.open().then(function () {
          window.PRIM.navigate('/start/');
        }, function () {
          window.PRIM.navigate('/offline/');
        }).catch(function (e) {
          window.PRIM.navigate('/offline/');
        });
      }, function (status) {
        switch (status) {
          case 'invalid':
            window.PRIM.navigate('/reentercredentials/');
            break;
          default:
            window.PRIM.navigate('/offline/');
            break;
        }
      }).catch(function (e) {
        window.PRIM.navigate('/offline/');
      });
    }
  }, {
    key: 'loadCredentials',
    value: function loadCredentials() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.localStorage.get({ name: 'settings' }, 'credentials').then(function (credentials) {
          if (credentials && credentials.username && credentials.password) {
            _this3.externalStorage.setCredentials(credentials.username, credentials.password);
            resolve();
            return;
          }
          console.warn('Failed to retrieve settings from local storage.');
          reject();
        }, function () {
          console.warn('Failed to retrieve settings from local storage.');
          reject();
        });
      });
    }
  }, {
    key: 'saveCredentials',
    value: function saveCredentials(username, password) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.localStorage.put({ name: 'settings' }, { id: 'credentials', username: username, password: password }).then(resolve, function () {
          console.warn('Failed to persist settings from local storage.');
          reject();
        });
      });
    }
  }, {
    key: 'capabilityCheck',
    value: function capabilityCheck() {
      var _this5 = this;

      this.setMessage('Controle browser...');

      if (typeof Promise === 'undefined') {
        this.setMessage('Helaas, uw browser voldoet niet aan de eisen om deze applicatie te kunnen draaien. Promises zijn niet beschikbaar. Werk indien mogelijk uw browser naar een nieuwere versie bij.');
        this.showReloadLink();
        return;
      }

      if (typeof window.crypto === 'undefined' || typeof window.crypto.subtle === 'undefined' && typeof window.crypto.webkitSubtle === 'undefined') {
        this.setMessage('Helaas, uw browser voldoet niet aan de eisen voor cryptografie. Veiligheid kan niet worden gegarandeerd. Werk indien mogelijk uw browser naar een nieuwere versie bij.');
        this.showReloadLink();
        return;
      }

      this.applicationManager.ondownloading = function () {
        _this5.setMessage('Update gevonden, applicatie wordt bijgewerkt...');
      };

      this.applicationManager.onprogress = function (e) {
        var message = 'Update gevonden, applicatie wordt bijgewerkt...';

        message += e.lengthComputable ? ' (' + (e.loaded + 1) + ' van ' + (e.total + 1) + ')' : '';

        _this5.setMessage(message);
      };

      this.applicationManager.onupdateready = function () {
        _this5.applicationManager.swapCache();
        _this5.setMessage('Applicatie is bijgewerkt. Herstarten vereist.');
        _this5.showReloadLink();
      };

      this.applicationManager.init().then(function () {
        _this5.initApplication();
      }, function () {
        _this5.setMessage('Helaas, door een onbekende fout kan PRIM niet gestart worden.');
        _this5.showReloadLink();
      });
    }
  }, {
    key: 'createReloadLink',
    value: function createReloadLink(visible) {
      this.reloadLink = document.createElement('a');
      this.reloadLink.href = '/';
      if (!visible) {
        this.reloadLink.setAttribute('style', 'display: none');
      }
      this.reloadLink.innerHTML = 'Herstarten';
      this.reloadLink.onclick = function (e) {
        e.preventDefault();
        location.reload(true);
      };
    }
  }, {
    key: 'createIndicator',
    value: function createIndicator() {
      this.indicator = document.createElement('div');
      this.indicator.id = 'loader';
    }
  }, {
    key: 'showWritePendingIndicator',
    value: function showWritePendingIndicator() {
      this.indicator.className = 'writePending';
    }
  }, {
    key: 'showWriteFailedIndicator',
    value: function showWriteFailedIndicator() {
      this.indicator.className = 'writeFailed';
    }
  }, {
    key: 'showWriteIndicator',
    value: function showWriteIndicator() {
      this.indicator.className = 'write';
    }
  }, {
    key: 'showReadPendingIndicator',
    value: function showReadPendingIndicator() {
      this.indicator.className = 'readPending';
    }
  }, {
    key: 'showReadIndicator',
    value: function showReadIndicator() {
      this.indicator.className = 'read';
    }
  }, {
    key: 'initNavigation',
    value: function initNavigation(start) {
      this.setMessage('Initialisatie navigatie...');
      this.navigationManager = new _NavigationManager2.default(this.viewport);
      if (!start) {
        window.PRIM.navigate('/welcome/');
      } else {
        window.PRIM.navigate(start);
      }
    }
  }, {
    key: 'setLicense',
    value: function setLicense(license) {
      this.License = license;
    }
  }, {
    key: 'hasReadonlyModuleAccess',
    value: function hasReadonlyModuleAccess(module) {
      return !this.License || !this.License.valid || this.License.moduleAccess[module] && this.License.moduleAccess[module] !== 'readwrite' && this.License.moduleAccess[module] !== 'demo';
    }
  }, {
    key: 'navigate',
    value: function navigate(uri, replace) {
      if (replace) {
        history.replaceState(null, document.title, '#' + uri);
      } else {
        history.pushState(null, document.title, '#' + uri);
        this.navigationManager.handleNavigation();
      }
    }
  }, {
    key: 'cancelDelayedNavigation',
    value: function cancelDelayedNavigation() {
      this.delayedNavigation = false;
    }
  }, {
    key: 'initDelayedNavigation',
    value: function initDelayedNavigation() {
      this.delayedNavigation = true;
    }
  }, {
    key: 'isDelayedNavigationActive',
    value: function isDelayedNavigationActive() {
      return this.delayedNavigation === true;
    }
  }, {
    key: 'getUUID',
    value: function getUUID() {
      var buffer = new Uint16Array(8);
      window.crypto.getRandomValues(buffer);

      var S4 = function S4(num) {
        var result = num.toString(16);
        while (result.length < 4) {
          result = '0' + result;
        }
        return result;
      };

      return S4(buffer[0]) + S4(buffer[1]) + '-' + S4(buffer[2]) + '-' + S4(buffer[3]) + '-' + S4(buffer[4]) + '-' + S4(buffer[5]) + S4(buffer[6]) + S4(buffer[7]);
    }
  }]);

  return Application;
}();

window.PRIM = null;

if (typeof addEventListener === 'function') {
  addEventListener('load', function () {
    window.PRIM = new Application();
    onerror = window.PRIM.exceptionHandler;
    window.PRIM.init();
  });
} else {
  window.onload = function () {
    var boot = document.getElementById('boot');
    var bootMessage = document.createElement('div');
    bootMessage.innerHTML = 'Helaas, uw browser voldoet niet aan de eisen om deze applicatie te kunnen draaien. Werk indien mogelijk uw browser naar een nieuwere versie bij.';
    var reloadLink = document.createElement('a');
    reloadLink.href = '.';
    reloadLink.setAttribute('style', 'display: none');
    reloadLink.innerText = 'Herstarten';
    reloadLink.onclick = function (e) {
      e.preventDefault();
      location.reload(true);
    };
    boot.appendChild(bootMessage);
    boot.appendChild(reloadLink);
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 0
// module chunks = 0